import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { Product } from '../types/product.type';

export type PublishProductPayload = {
  product_id: string;
};
export type PublishProductResponse = ApiResponse<Product>;

export const publishProduct = async (
  payload: PublishProductPayload
): Promise<PublishProductResponse> => {
  const { product_id } = payload;
  const url = `product/${product_id}/publish`;

  return await apiClient.patch(url);
};

export function publishProductMutationOptions() {
  return mutationOptions<
    PublishProductResponse,
    AxiosError,
    PublishProductPayload
  >({
    mutationFn: publishProduct,
  });
}
